module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container schedule-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.schedules.schedule_for')) + _vm._s(_vm.clinic.th.clinic_name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group",
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.appointment_active),
      expression: "clinic.appointment_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.appointment_active) ? _vm._i(_vm.clinic.appointment_active, null) > -1 : (_vm.clinic.appointment_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.appointment_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.appointment_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.appointment_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.appointment_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('message.schedules.online_appointment_on')))]), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('div', {
    staticClass: "disable-bg"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.instant_booking),
      expression: "clinic.instant_booking"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clinic.instant_booking) ? _vm._i(_vm.clinic.instant_booking, null) > -1 : (_vm.clinic.instant_booking)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clinic.instant_booking,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.clinic.instant_booking = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clinic.instant_booking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clinic.instant_booking = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Instant Booking")]), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$guser.isPremiumAccount()) ? _c('div', {
    staticClass: "disable-bg"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.select_time_slot')))])]), _vm._v(" "), _c('working-schedule', {
    attrs: {
      "schedules": _vm.clinic.schedules,
      "clinic_id": _vm.clinic.id,
      "time_slots": _vm.slotData.time_slots,
      "booking_per_slot": _vm.slotData.booking_per_slot
    },
    on: {
      "scheduleChanged": _vm.updateSchedules
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "lockModal",
    attrs: {
      "icon": "info",
      "title": "ฟังชั้นนี้ถูกปิดการใช้งานอยู่",
      "overlay-theme": "dark"
    }
  }, [_c('p', [_vm._v("ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.gotoPlanPage()
      }
    }
  }, [(!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Unlock")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-966e25be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/steps/Schedules.vue
// module id = 1043
// module chunks = 1